import { isEmpty } from '@/helpers'
import {OPPORTUNITY__BRANDS} from "@/constants";

export default {
  opportunityDetails (state) {
    return state.opportunityDetails
  },
  clientDetails (state) {
    return state.clientDetails
  },
  opportunityStatus (state) {
    return state.opportunityStatus
  },
  formatTypes (state) {
    return state.formatTypes
  },
  stepSelect (state) {
    return state.stepSelectData
  },
  permissions (state) {
    return state.permissionsData
  },
  opportunitySource (state) {
    // Original opportunity
    return state.opportunitySource
  },
  opportunity: (state, getters) => {
    const opportunitySource = getters.opportunitySource

    if (isEmpty(opportunitySource)) {
      return null
    }

    if (
      !Array.isArray(opportunitySource.itineraries) &&
      opportunitySource.itineraries.length > 0
    ) {
      return null
    }

    const opportunityCloned = { ...opportunitySource }
    const itinerariesSelected = opportunitySource.itineraries.filter(
      it => it.itinerary_source_type === state.itinerarySourceTypeSelected.value
    )

    delete opportunityCloned.itineraries

    opportunityCloned['itineraries'] = itinerariesSelected

    return opportunityCloned
  },
  getOpportunity (state) {
    return state.opportunity
  },
  opportunityBackup (state) {
    return state.opportunityBackup
  },
  opportunitiesSaved (state) {
    return state.opportunitiesSaved
  },
  itineraryDaysForReorder (state) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    const itinerary = state.opportunity
    if (itinerary) {
      const cloneItinerary = Object.assign({}, itinerary)
      return cloneItinerary.itineraries[indexItinerary].days
    }
    return []
  },
  locationsByDay (state) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    const itinerary = state.opportunity
    if (itinerary) {
      const cloneItinerary = Object.assign({}, itinerary)
      const days = cloneItinerary.itineraries[indexItinerary].days.map(day => {
        if (day.locations) {
          const locations = day.locations.map(location => {
            return {
              name: location.name,
              lat: location.location_latitude,
              lng: location.location_longitude
            }
          })
          return {
            id: day.id,
            title: day.title,
            locations,
            durations: day.duration
          }
        }
        return []
      })
      return days
    }
    return []
  },
  locationsVisited (state) {
    const indexItinerary = state.itinerarySourceTypeSelected.index
    const itinerary = state.opportunitySource
    if (itinerary) {
      const cloneItinerary = Object.assign({}, itinerary)
      const locationsVisited =
        cloneItinerary.itineraries[indexItinerary].locations_visited_coo
      return locationsVisited.filter(location => {
        return location.lat !== null || location.lng !== null
      })
    }
  },
  isReorderingItinerary (state) {
    return state.isReorderingItinerary
  },
  sourceTypes (state) {
    const brandId = state.opportunitySource.properties_opportunity.id_brand;
    const excluded = brandId === OPPORTUNITY__BRANDS.TRAFALGAR_RIVER
      ? ["ITP", "Uniworld TTC"]
      : ["ITP-Uniworld", "Uniworld TTC"]

    return state.sourceTypes.filter((sourceType => !excluded.includes(sourceType.text)))
  },
  itinerarySourceTypeSelected (state) {
    return state.itinerarySourceTypeSelected
  },
  existItineraryBySourceType: (state, getters) => sourceTypeId => {
    return getters.getSourceTypeIndex(sourceTypeId)
  },
  getSourceTypeIndex: (state, getters) => sourceTypeId => {
    const opportunitySource = getters.opportunitySource
    const itinerariesSource = opportunitySource.itineraries
    return itinerariesSource.findIndex(
      it => it.itinerary_source_type === sourceTypeId
    )
  },
  getItinerarySourceTypeById: (state, getters) => sourceTypeId => {
    if (state.sourceTypes) {
      return state.sourceTypes.find(st => st.text === sourceTypeId)
    }
    return { text: '' }
  },
  getItinerariesNumber (state) {
    if (!state.opportunitySource) {
      return 0
    }
    if (Array.isArray(state.opportunitySource.itineraries)) {
      return Number(state.opportunitySource.itineraries.length)
    }
    return 0
  },
  getItinerarySignature (state) {
    return state.signature
  },
  getAllowedBrandsIds (state) {
    const allowedBrandsIds = state.opportunityDetails.brands.filter(brand => {
      return brand.text === 'Contiki'
    })

    return allowedBrandsIds.map(brand => {
      return brand.value
    })
  }
}
